const prefix = 'caregiver:';
const baseUrl = process.env.VUE_APP_API_BASE_URL;

const AuthPlugin = {
  setImpersonation (impersonation) {
    localStorage.setItem(`${prefix}impersonation`, impersonation ? 1 : 0);
  },
  getImpersonation (impersonation) {
    return localStorage.getItem(`${prefix}impersonation`) ? true : false;
  },
  setToken (token) {
    localStorage.setItem(`${prefix}authToken`, token);
  },
  setRole(role) {
    localStorage.setItem(`${prefix}role`, role);
  },
  destroyToken() {
    localStorage.removeItem(`${prefix}authToken`);
    localStorage.removeItem(`${prefix}role`);
    localStorage.removeItem(`${prefix}name`);
  },
  getToken () {
    const token = localStorage.getItem(`${prefix}authToken`);
    if (!token) {
      return null;
    }
    return token;
  },
  refreshToken (success, error) {
    const self = this;
    $.ajax({
      url: `${baseUrl}auth/refresh-token`,
      async: false,
      method: 'POST',
      headers: { Authorization: `Bearer ${this.getToken()}` },
      success (res) {
        self.setToken(res.token);
        if (success) {
          success(res.token);
        }
      },
      error (res) {
        if (error) {
          error(res);
        }
      },
    });
  },
  setCurrentRoute (route, id) {
    if (route.name === 'login') {
      return false;
    }
    sessionStorage.setItem(`${prefix}redirectUserId`, id);
    sessionStorage.setItem(`${prefix}redirectLoginPathName`, route.name);
    sessionStorage.setItem(`${prefix}redirectLoginParams`, JSON.stringify(route.params));
    sessionStorage.setItem(`${prefix}redirectLoginQuery`, JSON.stringify(route.query));
  },
  redirectToLastRoute (router, id) {
    if (sessionStorage.getItem(`${prefix}redirectLoginPathName`) && sessionStorage.getItem(`${prefix}redirectUserId`) === id) {
      router.push({
        name: sessionStorage.getItem(`${prefix}redirectLoginPathName`),
        params: JSON.parse(sessionStorage.getItem(`${prefix}redirectLoginParams`)),
        query: JSON.parse(sessionStorage.getItem(`${prefix}redirectLoginQuery`)),
      });
      sessionStorage.removeItem(`${prefix}redirectLoginPathName`);
      sessionStorage.removeItem(`${prefix}redirectLoginParams`);
      sessionStorage.removeItem(`${prefix}redirectLoginQuery`);
    } else {
      router.push({ name: 'home' });
    }
  },
};

export default function (Vue) {
  Vue.auth = AuthPlugin;

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get () {
        return Vue.auth;
      },
    },
  });
}
